// Module
var code = "<div fc fc-options=\"vm.fullCalendarOptions\" ng-model=\"vm.eventSources\" class=\"fullcalendar-component\" on-init=\"vm.fullCalendarInitialized(calendar)\"></div> ";
// Exports
module.exports = code;